export default {
  header: {
    title: 'New Dispatch',
    dashboard: 'Dashboard',
    management: 'Management',
    dispatches: 'Dispatches',
    client: 'Client',
    workflow: 'Workflow',
    program: 'Program'
  },
  steps: {
    'Find Customer': 'Customer',
    'Select Service': 'Service',
    'Select Pick Up Time': 'Pick Up Time',
    'Select Pick Up Location': 'Pick Up Location',
    'Select Drop Off Location': 'Drop Off Location',
    'Select Provider': 'Select Provider',
    'Select Tire': 'Select Tire',
    'Review quote and accept payment': 'Payment',
    'Select Customer Location': 'Customer Location',
    'Secondary Towing Fees': 'Secondary Towing Fees'
  },
  forms: {
    couldNotLocateCustomerButton: 'Could Not Locate Customer',
    customer: 'Customer',
    customerHelpText: 'You can search by first name, last name, email, or phone number (numbers only for a phone number. no dashes or parenthesis needed)',
    name: 'Name',
    memberNumber: 'Member Number',
    email: 'Email',
    phones: 'Phones',
    address: 'Address',
    vehicles: 'Vehicles',
    chooseAVehicle: 'Choose a vehicle',
    requiredAVehicle: 'Vehicle is required. Edit customer to add a vehicle',
    vinRequired: 'Vehicle\'s VIN is required. Edit customer to add a vehicle\'s VIN',
    addANewVehicle: 'Add new vehicle',
    callerIsInASafeLocation: 'Caller is in a safe location',
    antiqueVehicle: 'Vehicle is an antique',
    vehicleIsLowered: 'Vehicle is lowered',
    forceAllServicesToCashCall: 'Force all services to cash call',
    chooseACallBackNumber: 'Choose a call back number',
    addCallbackNumber: 'Add callback number',
    fax: 'Fax',
    home: 'Home',
    mobile: 'Mobile',
    other: 'Other',
    programTfn: 'Program TFN',
    work: 'Work',
    benefitLevels: 'Benefit Levels',
    policyDetails: 'Policy Details',
    addresses: 'Addresses',
    customerNoPolicy: 'No Policy Required - Service All',
    customerBenefitLevelEligibilityValid: 'CUSTOMER BENEFIT ELIGIBILITY: VALID',
    customerBenefitLevelEligibilityInvalid: 'Policy is expired',
    policyNUmber: 'Policy Number',
    activeDate: 'Active Date',
    expirationDate: 'Expiration Date',
    cancellationDate: 'Cancellation Date',
    coverage: 'Coverage',
    covered: 'Covered',
    overMiles: 'Over Miles',
    emailNotVerified: 'EMAIL NOT VERIFIED',
    emailVerified: 'EMAIL VERIFIED',
    verify: 'Verify',
    emailNotFound: 'Email not found. Please click here to update email.',
    updateEmail: 'Update Email',
    type: 'Type',
    phone: 'Phone',
    situation: 'Situation',
    reasonForBreakdown: 'Reason For Breakdown',
    service: 'Service',
    yes: 'Yes',
    no: 'No',
    vehicleAdditionalCostWarning: 'Adding a vehicle to this plan will require an out of pocket expense. Are you sure you would like to continue?',
    callAgentScript: 'Call Agent Script',
    wouldLDTBeAcceptable: 'Would light duty towing be acceptable',
    vehicleShiftsOutOfPark: 'Does the vehicle shift out of park?',
    vehicleIsAWD: 'Is the vehicle 4WD (4 Wheel Drive) or AWD (All Wheel Drive)?',
    vehicleFacingForward: 'Is the vehicle forward facing or backed into the parking spot?',
    forwardFacing: 'Forward Facing',
    rearFacing: 'Rear Facing',
    inAParkingLot: 'Is the vehicle in a parking garage?',
    vehicleObstructed: 'Any other vehicles blocking access to your vehicle in order to perform the service?',
    engineStopWhileDriving: 'Did your engine stop running while driving?',
    currentlyInAParkingSpace: 'Is the vehicle currently in a parking space?',
    currentlyBackedIntoAParkingSpace: 'Is the vehicle backed into the parking space?',
    currentlyOtherVehiclesParkedAround: 'Are there other vehicles currently parked around your vehicle?',
    vehicleRequiresUnleadedFuel: 'Does the vehicle require unleaded fuel?',
    vehicleRequiresDieselFuel: 'Does the vehicle require diesel fuel?',
    vehicleKeysInPassengerCompartment: 'Keys inside the passenger compartment?',
    vehicleKeysInTrunk: 'Keys inside trunk?',
    vehicleKeysBroken: 'Are the keys to the vehicle broken?',
    vehicleHasPowerLocks: 'Does the vehicle have power locks?',
    vehicleHasGoodSpareTire: 'Does the vehicle have a good spare tire?',
    vehicleHasMoreThanOneFlatTire: 'Does the vehicle have more than one flat tire?',
    vehicleHasLockingHubCaps: 'Does the vehicle have locking hub caps or wheels?',
    personHasKeyForHubCaps: 'Do you have the key for the hub caps or wheels?',
    spareTireRequiresSpecialTool: 'Does your spare tire require a special tool to remove it?',
    personHasSpareTireSpecialTool: 'Do you have the special tool to remove the spare tire?',
    tireLeakingAirOverTime: 'Does the tire leak air over time?',
    airNozzleIsAccessibleWithOutRemovingHubCap: 'Is the air nozzle accessible without removing the hubcaps or wheels?',
    vehicleLessThanFifteenFtFromRoad: 'Is the vehicle less than 15 feet away from a paved area or road?',
    vehicleIsInDitch: 'Is the vehicle in a ditch',
    vehicleIsStuckInSandOrSnow: 'Is the vehicle stuck in snow or sand',
    vehicleLodgedOnCurbOrRailway: 'Is the vehicle lodges on a curb or railway',
    parkingLotGarageName: 'Parking Lot / Garage Name',
    nameOfParkingLotGarage: 'What is the name of the parking lot/garage?',
    parkedNextToColumn: 'Are you parked next to a column?',
    lessThanEightFootClearance: 'Is there less than an eight foot clearance in the parking lot/garage?',
    spaceRowNumber: 'Space / Row Number',
    whatIsSpaceRowNumber: 'What is the space number / row number?',
    lotGarage: 'Lot / Garage Floor',
    whatFloorIsTheVehicleLocatedOn: 'What floor is the vehicle located on?',
    lotGarageFloorDesignation: 'Lot / Garage Floor Designation',
    lotGarageFloorDesignationHelpText: 'Does the level or floor you parked on have a specific name, color or designation?',
    parkingFees: 'Parking Fees',
    parkingFeesHelperText: 'How much are the parking fees associated with the parking lot / garage',
    inParkingGarage: 'Is the vehicle in a parking garage?',
    isAccident: 'Is this service a result of an Accident?',
    vehicleFourWheelDrive: 'Is the vehicle 4WD (4 Wheel Drive) or AWD (All Wheel Drive)?',
    vehicleHasMoreThanFourTires: 'Does your vehicle have more than 4 tires?',
    vehicleHasRearFlatTire: 'Does your Vehicle have a rear flat tire?',
    vehicleHasLivingQuarters: 'Does your Vehicle have a living quarters?',
    vehicleHasDuallies: 'Does your Vehicle have duallies?',
    trailerIsLoaded: 'Is the trailer loaded?',
    vehicleHeight: 'What is the height of your vehicle?',
    vehicleWeight: 'What is the weight of your vehicle?',
    vehicleLength: 'What is the length of your vehicle?',
    vehicleHitchType: 'What type of hitch (Ball, Goose, Fifth Wheel)?',
    towForATrailer: 'Is this a tow for a trailer (no motor)?',
    areAnyTiresFlat: 'Are there any flat tires?',
    noSpareIsReasonForTow: 'Is having no spare the reason for a tow?',
    vehicleModifiedLower: 'Vehicle modified lower to the ground?',
    immediate: 'Immediate',
    scheduled: 'Scheduled',
    dateAndTime: 'Date and Time',
    unattendedTow: 'Unattended Tow',
    claimNumber: 'Claim Number',
    mechanical: 'Mechanical',
    accident: 'Accident',
    secondary: 'Secondary/Impound Tow',
    transport: 'Transport',
    recovery: 'Recovery',
    rvTechCall: 'RV Tech Call',
    pleaseReadThisToTheCustomer: 'Please Read This to the Customer',
    dial911: 'If you are injured and need medical help, please hang up and dial 911.',
    haveAClaimNumber: 'Do you have a claim number?',
    havePoliceBeenDispatched: 'Have the police been dispatched?',
    arePoliceOnScene: 'Are the police on scene?',
    acknowledgeAndAgree: 'Do you acknowledge and agree that the vehicle is being left unattended and waive all liability?',
    changeToAttendedTow: 'Change To Attended Tow',
    agree: 'Agree',
    disagree: 'Disagree',
    whereAreTheKeys: 'Where are the keys to the vehicle?',
    numberOfPeopleWhoNeedARide: 'Number of people who need a ride?',
    willTheCallerBeWithTheVehicle: 'Will the caller be with the vehicle?',
    firstName: 'First Name',
    lastName: 'Last Name',
    useCustomerAddress: 'Use customer address',
    pickALocationOnTheMap: 'Pick a location on the map or enter new location',
    dispatchMap: 'Dispatch Map',
    provider: 'Provider',
    searchingForAvailableProviders: 'Searching for available providers'
  }
};
